import React from "react";
import PropTypes from "prop-types";
import CheckoutContainer from "../CheckOutContainer/CheckoutContainer";
import CheckBox from "../CheckBox/CheckBox";
import { needsLocationAccessAcknowledgement } from "../../shared/utilities/locationAccessAcknowledgement";
import { orderCompleteRequirementMessages } from "../../shared/constants/order";
import styles from "./LocationAccessCheckoutReminder.module.css";

export const LOCATION_ACCESS_CHECKOUT_ERROR_ID =
  "location-access-checkout-error";

const LocationAccessCheckoutReminder = ({
  store,
  isChecked,
  onCheckedChange
}) => {
  if (!needsLocationAccessAcknowledgement(store)) {
    return null;
  }
  const showError = !isChecked;
  return (
    <div
      className={styles.wrapper}
      data-part="location-access-checkout-reminder"
    >
      <CheckoutContainer
        header={orderCompleteRequirementMessages.locationAccessCheckoutHeading}
        expanded
        forceDisableExpand
        keepHeaderVisibleWhenExpanded
      >
        <p className={styles.message}>{store.locationAccessMessage}</p>
        {showError ? (
          <p
            id={LOCATION_ACCESS_CHECKOUT_ERROR_ID}
            className={styles.errorMessage}
            role="alert"
          >
            {orderCompleteRequirementMessages.locationAccessAcknowledgement}
          </p>
        ) : null}
        <CheckBox
          label={
            orderCompleteRequirementMessages.locationAccessCheckoutCheckboxLabel
          }
          isChecked={isChecked}
          onClick={() => onCheckedChange(!isChecked)}
          ariaLabel={
            orderCompleteRequirementMessages.locationAccessCheckoutCheckboxLabel
          }
          ariaDescribedBy={
            !isChecked ? LOCATION_ACCESS_CHECKOUT_ERROR_ID : undefined
          }
        />
      </CheckoutContainer>
    </div>
  );
};

LocationAccessCheckoutReminder.propTypes = {
  store: PropTypes.shape({
    locationAccessMessage: PropTypes.string,
    name: PropTypes.string
  }).isRequired,
  isChecked: PropTypes.bool.isRequired,
  onCheckedChange: PropTypes.func.isRequired
};

export default LocationAccessCheckoutReminder;
